import React, { useEffect } from 'react';

import './LandingPageEcco.scss';
import ShoeRed from '../../static/images/shoe-red-1.png';
import ShoeYellow from '../../static/images/shoe-yellow-1.png';
import ShoeShadow from '../../static/images/shoe-shadow.png';
import soleLayer1 from '../../static/images/sole-layer-1.png';
import soleLayer2 from '../../static/images/sole-layer-2.png';
import soleLayerOutline from '../../static/images/sole-layer-outline.png';
import turtle from '../../static/images/turtlewithoutlegemptyy_desktop.png';
import turtleLeg from '../../static/images/onlylegturtle_desktop.png';
import quote from '../../static/images/quote.png';
import TrustpilotWidget from '../TrustpilotWidget/TrustpilotWidget';

const LandingPageEcco = ({
  headerText,
  headerButtonUrl1,
  headerButtonText1,
  headerButtonUrl2,
  headerButtonText2,
  headerBackgroundMobile,
  headerBackgroundMobile1,
  headerBackgroundMobile2,
  headerBackground,
  section1Text,
  soleFeaturesText1,
  soleFeaturesText2,
  soleFeaturesText3,
  soleFeaturesText4,
  sec2BackgroundMobile,
  sec2Background,
  sec2Text,
  sec2ButtonText1,
  sec2ButtonUrl1,
  sec2ButtonText2,
  sec2ButtonUrl2,
  sec3Title,
  sec3Text,
  sec3ButtonUrl,
  sec3ButtonText,
  soleFeaturesPlus,
  soleFeaturesMinus,
  sec4Text,
  sec5Background,
  sec5BackgroundMobile,
  sec5Text,
  sec5ButtonText1,
  sec5ButtonUrl1,
  sec5ButtonText2,
  sec5ButtonUrl2,
  sec6Background,
  sec6BackgroundMobile,
  sec6Text,
  sec6ButtonUrl,
  sec6ButtonText,
  sec8Image,
  sec8Text,
  sec8ButtonUrl,
  sec8ButtonText,
}) => {
  
  useEffect(() => {
    const { $ } = window;
    
    function msieversion() 
    {
        var ua = window.navigator.userAgent;
        var msie = ua.indexOf("MSIE ");
    
        if (msie > 0) // If Internet Explorer, return version number
        {
            //alert(parseInt(ua.substring(msie + 5, ua.indexOf(".", msie))));
        return true;
        }
        else  // If another browser, return 0
        {
           // alert('otherbrowser');
        return false;
        }
    
        
    }
    var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
    var isEdge = navigator.appVersion.indexOf("Edge");
    
    var windowHeight = window.innerHeight;
    var windowWidth = window.innerWidth;
    var prepare = windowHeight/4;
    
    $(document).ready(function(){
      var windowScroll = $(window).scrollTop();
      var soleFeatures = $('.sole-features-outer').offset().top;
      var sole = $('.sole-cont').offset().top;
      var turtle = $('.sec-turtle').offset().top;
      
      $('.sole-features, .shoe-sole, .sole, .foot-comfort-features, .turtle').addClass('animatable');
      
      if(msieversion() || isIE11 || isEdge != -1){
        $('html').addClass('ie');
      } 
      
      if((windowScroll + windowHeight - prepare*2 ) > soleFeatures){
        $('.sole-features, .shoe-sole').addClass('animate'); 
        $('.sole-features-feathers .feather').addClass('fadeInDown');
      }
      if((windowScroll + windowHeight - prepare*2 ) > sole){
        $('.sole, .foot-comfort-features').addClass('animate'); 
      } 
      if((windowScroll + windowHeight - prepare*2 ) > turtle){
        $('.turtle').addClass('fadeInLeft'); 
      }
     
      
      
      $(window).on('scroll', function(){
        if($('#slipper-animation').length){
          var slipper = $('#slipper-animation').offset().top;
           soleFeatures = $('.sole-features-outer').offset().top;
           sole = $('.sole-cont').offset().top;
           turtle = $('.sec-turtle').offset().top;
           
          var slipperScrollUpTO = 215; 
          if(windowWidth >= 375 && windowWidth < 410){
            slipperScrollUpTO = 250;
          }
          if(windowWidth >= 410 && windowWidth < 480){
            slipperScrollUpTO = 300;
          }
          if(windowWidth >= 480 && windowWidth < 768){
            slipperScrollUpTO = 350;
          }
          if(windowWidth >= 768 && windowWidth < 1200){
            slipperScrollUpTO = 350;
          }
          if(windowWidth >= 1200 && windowWidth < 1440){
            slipperScrollUpTO = 450;
          }
          if(windowWidth >= 1440 && windowWidth < 1600){
            slipperScrollUpTO = 520;
          }
          if(windowWidth >= 1600){
            slipperScrollUpTO = 580;
          }
          }
        windowScroll = $(window).scrollTop();
        
        var slipperScroll = windowScroll + windowHeight - slipper - prepare;
        if((windowScroll + windowHeight - prepare ) > slipper && slipperScroll > 0){
          //console.log(windowScroll);
          if(slipperScroll <= slipperScrollUpTO){
            $("#layer-inside").css({'transform': 'translateY('+slipperScroll/2.3+'px)',});
            $("#layer-bottom").css({'transform': 'translateY('+slipperScroll/1.6+'px)',});
            $("#layer-base").css({'transform': 'translateY('+slipperScroll/1.3+'px)',});
          }else{
            //console.log("slipperScrollUpTO : " + slipperScrollUpTO + " | slipperScroll : " + slipperScroll);
            
          } 
        }else{
          $("#layer-inside").css({'transform': 'translateY('+0+'px)',});
          $("#layer-bottom").css({'transform': 'translateY('+0+'px)',});
          $("#layer-base").css({'transform': 'translateY('+0+'px)',});
        }
         
        if((windowScroll + windowHeight - prepare*1.5 ) > soleFeatures){
          $('.sole-features, .shoe-sole').addClass('animate');
          $('.sole-features-feathers .feather').addClass('fadeInDown');
        }
        if((windowScroll + windowHeight - prepare*1.5 ) > sole){
          $('.sole, .foot-comfort-features').addClass('animate');	
        }
        if((windowScroll + windowHeight - prepare*1.5 ) > turtle){
          $('.turtle').addClass('fadeInLeft');	
        }
       
        
         
    
      });

     var totalCount = $(".featured .row .shoe").length;
     $('.featured .shoe').on('mouseover', function(){
       var count = $(this).index();
       //console.log(totalCount + ' current index: '+count);
       if(count + 1 == totalCount){
        $('.featured').addClass('last-child');
       }else{
         $('.featured').removeClass('last-child');
       }
     });
     
     $('.featured').on('mouseout', function(){
       $('.featured').removeClass('last-child');
     });
      
    
      
    });
  }, []);

  return (
    <div className="landingpage-ecco">
      <style>{`
        .landingpage-ecco .banner {
          background-image: url(${headerBackgroundMobile});
        }

        .landingpage-ecco .sec3 {
          background-image: url(${sec2BackgroundMobile});
        }

        .landingpage-ecco .sec4 {
          background-image: url(${sec6BackgroundMobile});
        }

        .landingpage-ecco .sec12 {
          background-image: url(${sec5BackgroundMobile});
        }

        @media (min-width: 992px) {
          .landingpage-ecco .banner {
            background-image: url(${headerBackground});
          }

          .landingpage-ecco .sec3 {
            background-image: url(${sec2Background});
          }

          .landingpage-ecco .sec4 {
            background-image: url(${sec6Background});
          }

          .landingpage-ecco .sec12 {
            background-image: url(${sec5Background});
          }
        }
      `}</style>

      <main className="contents">

        {/* Header */}
        <section className="banner">
          <div className="cta">
            <div className="container px-0 px-md-3">
              <div className="clearfix mb-md-0 content pt-xl-3">
                {headerText}
              </div>
              <div className="row compact mt-lg-5 pt-lg-5 btn-cont d-none d-lg-flex">
                <div className="col-6 text-right "><p className="pr-lg-5 mr-lg-4"><a href={headerButtonUrl1} className="btn btn-dark mb-3">{headerButtonText1}</a></p></div>
                <div className="col-6 text-left"><p className=" pl-lg-5 ml-lg-4"><a href={headerButtonUrl2} className="btn btn-dark mb-3">{headerButtonText2}</a></p></div>
              </div>
            </div>
          </div>
        </section>
        <section className="banner-xs d-lg-none">
          <div className="container-fluid px-0">
            <div className="row compact mx-0">
              <div className="col-6 pl-0 pr-1">
                <figure className="cover pointy">
                  <img src={headerBackgroundMobile1} alt="" />
                  <p className="action"><a href={headerButtonUrl1} className="btn btn-dark btn-block">{headerButtonText1}</a></p>
                </figure>
              </div>
              <div className="col-6 pr-0 pl-1">
                <figure className="cover round">
                  <img src={headerBackgroundMobile2} alt="" />
                  <p className="action"><a href={headerButtonUrl2} className="btn btn-dark btn-block">{headerButtonText2}</a></p>
                </figure>
              </div>
            </div>
          </div>
        </section>

        {/* Section 1 */}
        <section className="sec sec5 pb-0">
          <div className="container">
            <div className="row">
              <article className="content col-11 col-md-5 col-lg-5 col-xl-5">
                {section1Text}
              </article>
              <figure className="col-12 col-md-7 col-lg-7">
                <div className="sole-features-outer clearfix">
                  <div className="sole-features-cont clearfix">
                    <p className="shoe-sole animatable">
                      <img src={ShoeRed} className="shoe shoe-red" alt="" />
                      <img src={ShoeYellow} className="shoe shoe-yellow" alt="" />
                      <img src={ShoeShadow} className="shoe-shadow" alt="" />
                    </p>
                    <ul className="sole-features">
                      <li><em><span><em>{soleFeaturesText1}</em></span></em></li>
                      <li><em><span><em>{soleFeaturesText2}</em></span></em></li>
                      <li><em><span><em>{soleFeaturesText3}</em></span></em></li>
                      <li><em><span><em>{soleFeaturesText4}</em></span></em></li>
                    </ul>
                  </div>
                </div>
              </figure>
            </div>
          </div>
        </section> 

        {/* Section 2 */}
        <section className="sec sec3">
          <div className="container">
            <div className="row">
              <article className="content col-9 col-sm-9 col-md-7 col-lg-5 col-xl-4 ml-auto">
                {sec2Text}
                <p className="mt-lg-5 d-flex mb-0 text-center">
                <a href={sec2ButtonUrl1} className="btn btn-light mb-1 mr-2">{sec2ButtonText1}</a>
                <a href={sec2ButtonUrl2} className="btn btn-light mb-1 ml-2">{sec2ButtonText2}</a>  
                </p>
              </article>
            </div>
          </div>
        </section>


        {/* Section 3 */}
        <section className="sec sec-foot-comfort sec9 py-5">
          <div className="container">
            <div className="row">
              <div className="col-12 col-lg-5 col-xl-4 align-self-center mb-4 content">
                <h2>{sec3Title}</h2>
                <p className="d-none d-md-block">{sec3Text}</p>
                <p className="d-none d-md-block"><a href={sec3ButtonUrl} className="btn btn-dark">{sec3ButtonText}</a></p>
              </div>
              <div className="col-12  col-lg-7  col-xl-8 align-self-center">
                <div className="sole-cont">
                  <div className="row">
                    <figure className="col-12 col-sm-6 col-xl-7 align-self-center">
                      <p className="sole">
                        <img src={soleLayer1} className="sole-layer-1" alt="" />
                        <img src={soleLayer2} className="sole-layer-2" alt="" />
                        <img src={soleLayerOutline} className="sole-layer-outline" alt="" />
                      </p>
                    </figure>
                    <article className="col-12  col-sm-6  col-xl-5 pl-sm-5">
                      <ul className="foot-comfort-features">
                        <li><span>{soleFeaturesPlus}</span></li>
                        <li><span>{soleFeaturesMinus}</span></li>
                      </ul>
                    </article>
                  </div>
                </div>
              </div>
            </div>
            <div className="d-md-none">{sec3Text}</div>
            <div className="d-md-none"><a href={sec3ButtonUrl} className="btn btn-dark">{sec3ButtonText}</a></div>
          </div>
        </section>

        {/* Section 4 */}
        <section className="sec sec11 text-white sec-turtle">
          <div className="turtle animated slow">
            <img src={turtle} className="turtle-body" alt="" />
            <img src={turtleLeg} className="turtle-leg" alt="" />
          </div>
          <div className="container">
            <div className="row">
              <article className="content col-9 col-sm-10 col-md-6 col-lg-5 col-xl-4 ml-auto mb-lg-0">
                {sec4Text}
              </article>
            </div>
          </div>
        </section>

        {/* Section 5 */}
        <section className="sec sec12">
          <div className="container">
            <div className="row">
              <article className="content col-9 col-md-6 col-lg-5 col-xl-5  mb-lg-0 ml-auto">
                {sec5Text}
                <p className="mt-lg-5 mb-0 d-flex text-center">
                  <a href={sec5ButtonUrl1} className="btn btn-dark mb-1 mr-2">{sec5ButtonText1}</a>
                  <a href={sec5ButtonUrl2} className="btn btn-dark mb-1 ml-2">{sec5ButtonText2}</a>
                </p>
              </article>
            </div>
          </div>
        </section>

        {/* Section 6 */}
        <section className="p-2 p-sm-3 p-md-4 p-lg-5">
          <div className="container-fluid sec sec4 p-4 p-sm-5 p-lg-5 ">
            <div className="container px-0">
              <div className="row">
                <article className="content col-12 col-sm-8 col-md-7 col-lg-7 col-xl-7 pt-3 pt-sm-5  ">
                  {sec6Text}
                  <p className="mb-0"><a href={sec6ButtonUrl} className="btn btn-outline-light mb-3 ml-2">{sec6ButtonText}</a></p>
                </article>
              </div>
            </div>
          </div>
        </section>

        {/* Section 7 */}
        <section className="sec py-5 testimonials">
          <div className="container">
            <p className="text-center qoute pb-4"><img src={quote} alt="" /></p>
          </div>
          <div className="trustBox-widget py-4 py-lg-5 mb-5">
            <div className="container">
              <TrustpilotWidget />
            </div>
          </div>

          {/* Section 8 */}
          <div className="testimonials-products">
            <div className="container">
              <div className="row">
                <figure className="d-none d-md-block col-12 col-md-5">
                  <p><img src={sec8Image} alt="" /></p>
                </figure>
                <article className="content col-12 col-md-7 mb-lg-0 ml-md-auto">
                  {sec8Text}
                  <figure className="d-md-none"><img src={sec8Image} alt="" /></figure>
                  <p className="btn-cont mt-5 text-center text-md-left">
                    <a href={sec8ButtonUrl} className="btn btn-dark  d-md-inline-block mb-3">{sec8ButtonText}</a>
                  </p>
                </article>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  )
}

LandingPageEcco.defaultProps = {
  locale: 'de-DE',
  headerText: <><h1>ECO</h1><span>100% RECYCLED OCEAN PET PLASTIC</span><h1><strong>FLATS</strong><br/>€129</h1></>,
  headerButtonText1: 'Pointy',
  headerButtonUrl1: '#',
  headerButtonText2: 'Round',
  headerButtonUrl2: '#',
  headerBackgroundMobile: 'http://rothierdesign.com/projects/giesswein/ecco/images/banner-sm.jpg',
  headerBackgroundMobile1: 'http://rothierdesign.com/projects/giesswein/ecco/images/pointy.jpg',
  headerBackgroundMobile2: 'http://rothierdesign.com/projects/giesswein/ecco/images/round.jpg',
  headerBackground: 'http://rothierdesign.com/projects/giesswein/ecco/images/banner.jpg',
  section1Text: <><h2>Discover our stylish flats made from <br /><strong>recycled ocean pet.</strong></h2><p>Environmental protection is more comfortable than ever with our GIESSWEIN flats. Due to the 3D-knitting technology our flats are perfect for every foot shape.</p></>,
  soleFeaturesText1: <>2 styles: <br /><strong>Pointy</strong> and <strong>Round</strong></>,
  soleFeaturesText2: <>100 % recycled ocean PET plastic</>,
  soleFeaturesText3: <>3D Comfort strecht effect</>,
  soleFeaturesText4: <>100% biodegradable sole</>,
  sec2Text: <><h2>The perfect  <br /> <strong>shoe for <br />every day</strong></h2><p>The extra soft PET plastic yarn is refined by our GIESSWEIN 3D-Knit technology and crafted into a super soft lifestyle shoe.</p></>,
  sec2BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec3-sm.jpg',
  sec2Background: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec3.jpg',
  sec2ButtonText1: 'Pointy',
  sec2ButtonUrl1: '#',
  sec2ButtonText2: 'Round',
  sec2ButtonUrl2: '#',
  sec3Title: <>Foot comfort <strong>reinvented.</strong></>,
  sec3Text: 'In our flats, we’re using an unprecedented fit system: With each pair of our flats, you’ll receive a second insole. This second insole allows you to adjust your shoe to fit a half-size larger or half-size smaller. Exactly adapted to your needs!',
  sec3ButtonUrl: '#',
  sec3ButtonText: 'Buy insoles',
  soleFeaturesPlus: 'With the additional insole you can adjust your ballerinas to fit a half a size smaller.',
  soleFeaturesMinus: 'With only one insole, the ballerinas match with your ordered size.',
  sec4Text: <><h2><strong>Sustainability</strong> <br /> on a whole new level.</h2><p>Recycled ocean PET plastic meets a 100% biodegradable sole. By choosing these materials and looking to new technologies, we sustainably reduce our ecological footprint. Our flats are the first choice for elegant footwear with a low ecological footprint.</p></>,
  sec5Background: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec12.jpg',
  sec5BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec12-sm.jpg',
  sec5Text: <><h2>Odours don’t <br /><strong>stand a chance.</strong></h2><p>Throughout the three generations of our company’s family owned and operated business, we’ve learned to combine our knowledge of wool craftsmanship with modern, green thinking about the environment and animal protection</p></>,
  sec5ButtonText1: 'Pointy',
  sec5ButtonUrl1: '#',
  sec5ButtonText2: 'Round',
  sec5ButtonUrl2: '#',
  sec6Background: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec4.jpg',
  sec6BackgroundMobile: 'http://rothierdesign.com/projects/giesswein/ecco/images/bg-sec4-sm.jpg',
  sec6Text: <><h2><strong>100% recycled</strong> <br /> plastic</h2><p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam libero ligula, dignissim ac suscipit eget, ullamcorper in tellus. Curabitur consequat neque et enim ultricies, id pellentesque massa congue. Aliquam erat volutpat. </p></>,
  sec6ButtonUrl: '#',
  sec6ButtonText: 'Know more',
  sec8Image: 'http://rothierdesign.com/projects/giesswein/ecco/images/shoe-gray-2.jpg',
  sec8Text: <><h3>See our full range of  <br className="d-none d-md-block" /> <strong>eco merino wool shoes</strong> </h3></>,
  sec8ButtonUrl: '#',
  sec8ButtonText: 'Shop Merino Shoes',
}

export default LandingPageEcco;